var _metadata, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _g, _tspan, _tspan2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg853",
    xmlSpace: "preserve",
    width: 699.67792,
    height: 389.48935,
    viewBox: "0 0 699.67792 389.48935",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata859"
  }, "image/svg+xml")), /*#__PURE__*/React.createElement("defs", {
    id: "defs857"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath871"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,1.2207e-4 H 960 V 540.00012 H 0 Z",
    id: "path869",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath881"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.4305e-5,0 H 960.00001 V 540 H 1.4305e-5 Z",
    id: "path879",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath893"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.4305e-5,0 H 960.00001 V 540 H 1.4305e-5 Z",
    id: "path891",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath933"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 458.25,171 H 640.5 V 339.75 H 458.25 Z",
    id: "path931",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath943"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path941"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath965"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 473.09,291.01 18.8,-44.83 -44.83,-18.8 -18.8,44.83 z",
    id: "path963",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath975"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path973"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath985"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 466.97,199.73 59.42,-27.62 -27.62,-59.43 -59.43,27.63 z",
    id: "path983",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath995"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path993"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1009"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -6.1035e-5,540 H 960 V 0 H -6.1035e-5",
    id: "path1007",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1019"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -6.1035e-5,540 H 960 V 0 H -6.1035e-5",
    id: "path1017",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1029"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -6.1035e-5,540 H 960 V 1.8311e-4 L -9.1553e-5,1.2207e-4",
    id: "path1027",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1039"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M -6.1035e-5,540 H 960 V 1.8311e-4 L -9.1553e-5,1.2207e-4",
    id: "path1037",
    style: {
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1053"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 520.31,189.89 71.27,-10.21 -10.21,-71.27 -71.27,10.21 z",
    id: "path1051",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1063"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path1061"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1075"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 594.4,190.68 70.41,-15.05 -15.04,-70.41 -70.41,15.05 z",
    id: "path1073",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1085"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path1083"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1097"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 548.98,147.95 46.67,-6.07 -6.07,-46.676 -46.67,6.076 z",
    id: "path1095",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1107"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path1105"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1119"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 134.25,156 H 300 V 321.75 H 134.25 Z",
    id: "path1117",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1129"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path1127"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1139"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 285.29,313.44 348.07,278.18 312.8,215.4 250.03,250.67 Z",
    id: "path1137",
    style: {
      clipRule: "evenodd"
    }
  })), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath1149"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 72.75 V 72.75 H 0 Z",
    id: "path1147"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g861",
    transform: "matrix(1.3333333,0,0,-1.3333333,-194.62744,508.16463)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 145.97058,89.00645 H 670.72904 V 381.12348 H 145.97058 Z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.54378301
    },
    id: "path863"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g865",
    transform: "translate(0,-6e-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g877",
    clipPath: "url(#clipPath881)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,494.7)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontSize: "39.79999924px",
      fontFamily: "TimesNewRomanPSMT",
      InkscapeFontSpecification: "TimesNewRomanPSMT",
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text885"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "0 26.268 44.257599 64.475998 82.465599 93.689201 107.1814 116.216 136.4344 156.6528 176.8712 192.59219 210.5818 230.8002 251.0186 261.52579 281.7442 290.77881 308.7684 328.98679 349.2052 359.7124 370.936 388.9256 409.14401 427.13361 445.1232",
    y: 0,
    id: "tspan883"
  }, "Repair household appliances"))))), /*#__PURE__*/React.createElement("g", {
    id: "g887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g889",
    clipPath: "url(#clipPath893)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,477.83,494.7)",
    style: {
      fontVariant: "normal",
      fontWeight: "normal",
      fontSize: "39.79999924px",
      fontFamily: "TimesNewRomanPSMT",
      InkscapeFontSpecification: "TimesNewRomanPSMT",
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "text897"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "0 13.4524 39.720402",
    y: 0,
    id: "tspan895"
  }, "(R)"))))), /*#__PURE__*/React.createElement("path", {
    d: "m 328.88,260.25 c 0,27.96 22.66,50.62 50.62,50.62 27.96,0 50.63,-22.66 50.63,-50.62 0,-27.96 -22.67,-50.63 -50.63,-50.63 -27.96,0 -50.62,22.67 -50.62,50.63 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path899"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 328.88,260.25 c 0,27.96 22.66,50.62 50.62,50.62 27.96,0 50.63,-22.66 50.63,-50.62 0,-27.96 -22.67,-50.63 -50.63,-50.63 -27.96,0 -50.62,22.67 -50.62,50.63 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path901"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 357.38,187.87 h 17.25 v 44.25 h -17.25 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path903"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 357.38,187.87 h 17.25 v 44.25 h -17.25 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 385.13,187.87 h 17.25 v 44.25 h -17.25 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 385.13,187.87 h 17.25 v 44.25 h -17.25 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 351.38,270.75 c 0,8.91 7.55,16.12 16.87,16.12 9.32,0 16.88,-7.21 16.88,-16.12 0,-8.91 -7.56,-16.13 -16.88,-16.13 -9.32,0 -16.87,7.22 -16.87,16.13 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 351.38,270.75 c 0,8.91 7.55,16.12 16.87,16.12 9.32,0 16.88,-7.21 16.88,-16.12 0,-8.91 -7.56,-16.13 -16.88,-16.13 -9.32,0 -16.87,7.22 -16.87,16.13 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 374.63,270.75 c 0,8.91 7.55,16.12 16.87,16.12 9.32,0 16.88,-7.21 16.88,-16.12 0,-8.91 -7.56,-16.13 -16.88,-16.13 -9.32,0 -16.87,7.22 -16.87,16.13 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path915"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 374.63,270.75 c 0,8.91 7.55,16.12 16.87,16.12 9.32,0 16.88,-7.21 16.88,-16.12 0,-8.91 -7.56,-16.13 -16.88,-16.13 -9.32,0 -16.87,7.22 -16.87,16.13 z",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 371.05,268.81 c 0,-1.08 -0.87,-1.95 -1.95,-1.95 -1.07,0 -1.95,0.87 -1.95,1.95 0,1.07 0.88,1.95 1.95,1.95 1.08,0 1.95,-0.88 1.95,-1.95 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 389.99,269.01 c 0,-1.08 -0.88,-1.95 -1.95,-1.95 -1.08,0 -1.95,0.87 -1.95,1.95 0,1.07 0.87,1.94 1.95,1.94 1.07,0 1.95,-0.87 1.95,-1.94 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path921"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 354.38,304.12 25.5,49.5 25.5,-49.5 z",
    style: {
      fill: "#4472c4",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path923"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 354.38,304.12 25.5,49.5 25.5,-49.5 z",
    style: {
      fill: "none",
      stroke: "#2f528f",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path925"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g929",
    clipPath: "url(#clipPath933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g935",
    transform: "matrix(2.5312,-1.88e-7,-7.54e-7,2.3437,458.25,171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g937",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g939",
    clipPath: "url(#clipPath943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 12.384,66.366 v -60 h 48 v 60 z m 46.5,-1.5 v -11.25 h -45 v 11.25 z m -45,-57 v 44.25 h 45 V 7.866 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.384,45.366 c -8.284,0 -15,-6.716 -15,-15 0,-8.284 6.716,-15 15,-15 8.284,0 15,6.716 15,15 -0.01,8.28 -6.72,14.99 -15,15 z m 0,-28.5 c -7.456,0 -13.5,6.044 -13.5,13.5 0,7.456 6.044,13.5 13.5,13.5 7.456,0 13.5,-6.044 13.5,-13.5 -0.009,-7.452 -6.048,-13.491 -13.5,-13.5 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.384,40.866 c -5.799,0 -10.5,-4.701 -10.5,-10.5 0,-5.799 4.701,-10.5 10.5,-10.5 5.799,0 10.5,4.701 10.5,10.5 -0.006,5.796 -4.704,10.494 -10.5,10.5 z m 0,-19.5 c -4.197,0.007 -7.834,2.911 -8.769,7.003 0.323,-0.093 0.658,-0.136 0.994,-0.129 0.928,0.034 1.8,0.458 2.4,1.168 0.712,0.78 1.923,0.835 2.703,0.122 0.042,-0.038 0.083,-0.079 0.122,-0.122 1.201,-1.408 3.317,-1.576 4.725,-0.375 0.135,0.115 0.26,0.241 0.375,0.375 0.354,0.415 0.871,0.654 1.416,0.653 h 0.009 c 0.542,-0.001 1.055,-0.239 1.405,-0.653 0.822,-0.993 2.156,-1.401 3.393,-1.039 -0.935,-4.093 -4.574,-6.998 -8.773,-7.003 z m 8.986,8.718 c -0.776,-0.557 -1.848,-0.427 -2.468,0.3 -0.634,0.746 -1.564,1.177 -2.543,1.177 h -0.008 c -0.983,0 -1.916,-0.43 -2.555,-1.178 -0.712,-0.78 -1.922,-0.835 -2.702,-0.122 -0.042,0.039 -0.083,0.08 -0.122,0.122 -0.637,0.747 -1.569,1.177 -2.55,1.178 v 0 c -0.982,0 -1.914,-0.431 -2.55,-1.178 -0.331,-0.39 -0.81,-0.624 -1.321,-0.643 -0.411,-0.017 -0.815,0.105 -1.149,0.345 0,0.094 -0.014,0.186 -0.014,0.281 0,4.971 4.029,9 9,9 4.97,0 9,-4.029 9,-9 -0.004,-0.095 -0.015,-0.188 -0.018,-0.282 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path949"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 36.759,56.616 c 1.45,0 2.625,1.175 2.625,2.625 0,1.45 -1.175,2.625 -2.625,2.625 -1.45,0 -2.625,-1.175 -2.625,-2.625 0,-1.45 1.175,-2.625 2.625,-2.625 z m 0,3.75 c 0.621,0 1.125,-0.504 1.125,-1.125 0,-0.621 -0.504,-1.125 -1.125,-1.125 -0.621,0 -1.125,0.504 -1.125,1.125 0,0.621 0.504,1.125 1.125,1.125 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path951"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 44.259,56.616 c 1.45,0 2.625,1.175 2.625,2.625 0,1.45 -1.175,2.625 -2.625,2.625 -1.45,0 -2.625,-1.175 -2.625,-2.625 0,-1.45 1.175,-2.625 2.625,-2.625 z m 0,3.75 c 0.621,0 1.125,-0.504 1.125,-1.125 0,-0.621 -0.504,-1.125 -1.125,-1.125 -0.621,0 -1.125,0.504 -1.125,1.125 0,0.621 0.504,1.125 1.125,1.125 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path953"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 51.759,56.616 c 1.45,0 2.625,1.175 2.625,2.625 0,1.45 -1.175,2.625 -2.625,2.625 -1.45,0 -2.625,-1.175 -2.625,-2.625 0,-1.45 1.175,-2.625 2.625,-2.625 z m 0,3.75 c 0.621,0 1.125,-0.504 1.125,-1.125 0,-0.621 -0.504,-1.125 -1.125,-1.125 -0.621,0 -1.125,0.504 -1.125,1.125 0,0.621 0.504,1.125 1.125,1.125 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 28.884,61.866 h -10.5 v -5.25 h 10.5 z m -1.5,-3.75 h -7.5 v 2.25 h 7.5 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path957"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g961",
    clipPath: "url(#clipPath965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g967",
    transform: "matrix(0.62266,0.26112,-0.26112,0.62266,447.06,227.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g969",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g971",
    clipPath: "url(#clipPath975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 66.59,70.371 -7.778,-6.225 -2.045,-4.088 -24.876,-24.875 -3.075,3.15 -3.243,-3.242 0.531,-0.53 c 0.258,-0.249 0.402,-0.593 0.399,-0.951 -0.01,-0.323 -0.155,-0.627 -0.399,-0.839 -0.247,-0.26 -0.592,-0.405 -0.951,-0.399 -0.312,0.007 -0.606,0.143 -0.814,0.375 L 23.814,33.328 4.5127,14.103 C 3.8324,13.453 3.3072,12.659 2.976,11.778 2.1055,9.2495 2.7572,6.446 4.6537,4.5607 7.0066,2.1772 10.748,1.869 13.459,3.8355 l 0.88,0.7252 19.055,19.0553 -0.53,0.53 c -0.258,0.249 -0.402,0.593 -0.399,0.951 0.01,0.323 0.155,0.627 0.399,0.839 0.25,0.257 0.593,0.401 0.951,0.399 0.312,-0.007 0.606,-0.143 0.814,-0.375 l 0.529,-0.582 3.18,3.18 -3.15,3.225 24.89,24.891 4.09,2.042 6.219,7.858 z M 36.229,28.572 35.128,27.47 c -0.387,0.229 -0.826,0.354 -1.275,0.364 -0.758,0.015 -1.489,-0.278 -2.025,-0.813 -0.536,-0.483 -0.849,-1.166 -0.864,-1.888 -0.012,-0.508 0.118,-1.01 0.375,-1.45 L 13.334,5.6715 12.546,5.025 C 10.432,3.5159 7.5333,3.7705 5.7142,5.625 4.2263,7.1014 3.712,9.2979 4.3897,11.281 c 0.2578,0.668 0.6614,1.269 1.1813,1.76 l 18.268,18.196 c 0.387,-0.229 0.826,-0.354 1.275,-0.364 0.759,-0.019 1.491,0.275 2.025,0.813 0.536,0.483 0.849,1.166 0.864,1.888 0.012,0.508 -0.118,1.01 -0.375,1.449 l 1.175,1.176 2.566,-2.629 1.715,-1.771 v 0 l 0.491,-0.502 0.024,-0.025 v 0 z M 63.199,59.912 59.19,57.907 34.14,32.857 32.934,34.108 58,59.172 l 2.009,4.011 6.472,5.175 1.903,-1.903 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path977"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g981",
    clipPath: "url(#clipPath985)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g987",
    transform: "matrix(0.82532,-0.38365,0.38365,0.82532,439.34,140.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g989",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g991",
    clipPath: "url(#clipPath995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 45.527,34.978 -1.06,-1.062 19.769,-19.725 c 1.03,-1.641 0.83,-3.769 -0.488,-5.1903 -0.755,-0.7506 -1.777,-1.173 -2.842,-1.176 -0.814,-0.0028 -1.608,0.253 -2.267,0.7305 0,0 -0.249,0.1695 -0.406,0.3 -0.044,0.036 -0.164,0.15 -0.164,0.15 L 38.788,28.238 37.727,27.178 57.042,7.9492 57.759,7.341 c 0.916,-0.6632 2.019,-1.0188 3.15,-1.0155 1.463,0.0011 2.865,0.5821 3.9,1.6155 1.864,1.9624 2.113,4.956 0.6,7.2 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path997"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 56.158,45.772 c 5.636,-0.026 10.226,4.522 10.251,10.158 0.006,1.287 -0.232,2.563 -0.7,3.761 l -6.075,-6.075 -4.8,1.275 -1.2,4.725 6.075,6.075 c -1.136,0.426 -2.339,0.643 -3.551,0.643 -2.566,-0.006 -5.039,-0.956 -6.949,-2.668 -2.836,-2.599 -3.992,-6.559 -3,-10.275 L 34.375,41.557 17.948,57.966 16.054,61.678 8.9542,67.372 5.3782,63.796 11.078,56.695 14.784,54.802 31.209,38.396 7.959,15.141 C 6.6166,13.843 6.0727,11.925 6.534,10.116 6.991,8.3089 8.4019,6.8979 10.209,6.441 c 1.809,-0.4541 3.723,0.0888 5.025,1.425 l 38.25,38.25 c 0.873,-0.228 1.772,-0.343 2.674,-0.344 z m -40.395,10.174 -3.72,1.94 -4.6503,5.8 1.674,1.674 5.8003,-4.65 1.853,-3.644 16.593,-16.568 -1.04,-1.039 z m 36.66,-8.77 -38.25,-38.2495 c -0.708,-0.7247 -1.676,-1.1362 -2.689,-1.143 -0.307,0 -0.613,0.0381 -0.911,0.1132 C 9.3059,8.2225 8.3159,9.2122 7.9897,10.48 7.665,11.763 8.0456,13.122 8.9895,14.05 l 0.0157,0.015 0.015,0.015 38.2498,38.25 0.608,0.607 -0.217,0.829 c -0.865,3.173 0.12,6.563 2.55,8.779 1.771,1.594 4.107,2.412 6.486,2.27 l 0.005,-0.014 -4.732,-4.728 1.627,-6.405 6.487,-1.725 4.777,4.777 c 0.006,0.007 0.013,0.005 0.013,-0.005 0.187,-2.405 -0.614,-4.783 -2.218,-6.584 -1.664,-1.83 -4.025,-2.869 -6.498,-2.861 -0.775,0.002 -1.547,0.103 -2.297,0.3 l -0.831,0.216 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 11.55,13.191 c -0.948,0 -1.7163,-0.768 -1.7168,-1.715 -4e-4,-0.948 0.7678,-1.7166 1.7148,-1.717 0.948,-5e-4 1.717,0.768 1.717,1.715 0,0 0,10e-4 0,10e-4 0,0.947 -0.768,1.716 -1.715,1.716 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1001"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1005",
    clipPath: "url(#clipPath1009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 329.24,248.45 -13.48,4.27 c -7.45,2.36 -12.33,7.94 -10.89,12.46 1.43,4.53 8.63,6.29 16.07,3.94 l 13.49,-4.27 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path1011"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1015",
    clipPath: "url(#clipPath1019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 329.24,248.45 -13.48,4.27 c -7.45,2.36 -12.33,7.94 -10.89,12.46 1.43,4.53 8.63,6.29 16.07,3.94 l 13.49,-4.27 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1021"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1025",
    clipPath: "url(#clipPath1029)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 417.05,268.57 19.33,-2.9 c 10.68,-1.61 18.63,-7.62 17.75,-13.44 -0.87,-5.82 -10.23,-9.23 -20.91,-7.63 l -19.33,2.9 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path1031"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g1033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1035",
    clipPath: "url(#clipPath1039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 417.05,268.57 19.33,-2.9 c 10.68,-1.61 18.63,-7.62 17.75,-13.44 -0.87,-5.82 -10.23,-9.23 -20.91,-7.63 l -19.33,2.9 z",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1041"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m 395.63,239.63 c 0,-5.39 -7.22,-9.76 -16.13,-9.76 -8.91,0 -16.12,4.37 -16.12,9.76 h 4.87 c 0,-2.7 5.04,-4.88 11.25,-4.88 6.21,0 11.25,2.18 11.25,4.88 z",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path1043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 395.63,239.63 c 0,-5.39 -7.22,-9.76 -16.13,-9.76 -8.91,0 -16.12,4.37 -16.12,9.76 h 4.87 c 0,-2.7 5.04,-4.88 11.25,-4.88 6.21,0 11.25,2.18 11.25,4.88 z",
    style: {
      fill: "none",
      stroke: "#a5a5a5",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path1045"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1049",
    clipPath: "url(#clipPath1053)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1055",
    transform: "rotate(171.84567,289.38612,110.92398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1057",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1059",
    clipPath: "url(#clipPath1063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.084,65 41.827,58.742 39.609,56.541 V 48.066 L 8.559,17.016 C 7.3785,15.863 7.3563,13.971 8.5093,12.791 8.5257,12.774 8.5423,12.757 8.559,12.741 l 4.275,-4.275 c 1.153,-1.1805 3.045,-1.2027 4.225,-0.0497 0.017,0.0164 0.034,0.033 0.05,0.0497 l 30.975,31.05 h 8.475 l 2.237,2.256 6.258,6.258 z m 0,-23.984 H 47.461 L 47.022,40.576 16.047,9.5257 C 15.479,8.9309 14.536,8.9094 13.941,9.4777 13.925,9.4933 13.909,9.5093 13.893,9.5257 L 9.618,13.801 c -0.5948,0.568 -0.6164,1.511 -0.0481,2.106 0.0157,0.016 0.0317,0.032 0.0481,0.048 l 31.05,31.05 0.439,0.439 v 8.475 l 0.459,0.456 14.861,-14.863 -0.493,-0.496 z m 9.647,1.812 -0.248,-0.251 -14.85,14.85 0.254,0.253 5.197,5.198 14.85,-14.85 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1065"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.609,41.841 c -1.243,0 -2.25,-1.007 -2.25,-2.25 0,-1.243 1.007,-2.25 2.25,-2.25 1.243,0 2.25,1.007 2.25,2.25 0,1.243 -1.007,2.25 -2.25,2.25 z m 0,-3 c -0.414,0 -0.75,0.336 -0.75,0.75 0,0.414 0.336,0.75 0.75,0.75 0.414,0 0.75,-0.336 0.75,-0.75 0,-0.414 -0.336,-0.75 -0.75,-0.75 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1067"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1071",
    clipPath: "url(#clipPath1075)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1077",
    transform: "matrix(0.97793,-0.20893,0.20893,0.97793,579.36,120.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1079",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1081",
    clipPath: "url(#clipPath1085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 53.638,13.866 H 9.3877 c -1.6568,0 -3,1.343 -3,3 0,1.657 1.3432,3 3,3 h 6.0003 v 31.5 h 37.05 l 1.5,1.5 h -38.55 v 7.5 H 9.3877 c -2.484,-0.003 -4.4971,-2.016 -4.5,-4.5 v -39 c 0.0029,-2.484 2.016,-4.497 4.5,-4.5 H 55.138 v 25.888 l -1.5,-1.5 z m -47.2503,42 c 0,1.657 1.3432,3 3,3 h 4.5003 v -37.5 H 9.3877 c -1.1076,0.001 -2.1762,-0.409 -3,-1.149 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.444,58.851 -2.625,2.625 c -0.569,0.582 -1.504,0.592 -2.086,0.022 -0.007,-0.007 -0.014,-0.015 -0.022,-0.022 L 46.563,42.291 46.461,42.052 44.83,37.012 34.762,46.605 20.344,32.932 23.667,29.61 v -9.744 h 9.75 v 8.593 h 2.625 v -8.593 h 9.75 V 31.159 L 34.729,41.668 23.96,31.438 l -1.466,1.466 12.265,11.632 9.65,-9.195 6.611,2.152 0.308,0.131 19.08,19.155 c 0.581,0.511 0.638,1.396 0.128,1.978 -0.029,0.032 -0.06,0.064 -0.092,0.094 z M 25.167,30.516 34.729,39.6 44.292,30.516 v -9.15 h -6.75 v 8.593 h -5.625 v -8.593 h -6.75 z m 25.617,8.684 -0.264,-0.264 -3.133,-1.033 -0.509,0.509 1.028,3.1 0.307,0.308 c 0.302,0.184 0.649,0.282 1.003,0.283 0.502,0 0.983,-0.201 1.335,-0.559 0.64,-0.62 0.738,-1.61 0.233,-2.344 z M 65.74,54.16 52.522,40.941 c -0.288,1.299 -1.308,2.31 -2.609,2.586 l 13.233,13.264 0.251,0.252 2.604,-2.602 z m 1.293,1.367 -2.576,2.576 2.308,2.306 2.575,-2.576 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1089"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g1091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1093",
    clipPath: "url(#clipPath1097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1099",
    transform: "matrix(0.64826,-0.084338,0.084337,0.64826,542.91,101.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1101",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1103",
    clipPath: "url(#clipPath1107)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 30.684,41.841 -1.425,3.525 -13.875,-5.625 1.425,-3.45 5.4,0.525 10.65,-26.4 4.05,-4.05 0.15,5.7 -10.65,26.475 z M 17.347,38.916 28.434,43.411 28.87,42.334 25.495,39.728 25.486,39.722 22.04,38.306 17.773,37.891 Z m 18.204,-27.122 -0.05,-1.903 -1.367,1.369 -10.516,26.073 1.424,0.586 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 55.134,39.141 -20.475,19.8 2.475,4.8 -2.625,2.625 -10.425,-10.8 2.7,-2.625 4.725,2.775 20.55,-19.8 5.325,-2.025 z m -28.125,15.675 -0.809,0.787 8.325,8.625 0.771,-0.771 -1.973,-3.825 -0.23,-0.45 -1.817,-1.863 -0.525,-0.309 z m 25.87,-17.607 -20.17,19.432 1.054,1.078 20.111,-19.447 0.739,-1.725 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1111"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1115",
    clipPath: "url(#clipPath1119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1121",
    transform: "matrix(2.3021,-1.88e-7,-1.88e-7,2.3021,134.25,156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1123",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1125",
    clipPath: "url(#clipPath1129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 61.134,38.616 h -11.25 v 4.5 h 1.5 c 0.414,0 0.75,0.336 0.75,0.75 0,0.414 -0.336,0.75 -0.75,0.75 h -4.5 c -0.414,0 -0.75,-0.336 -0.75,-0.75 0,-0.414 0.336,-0.75 0.75,-0.75 h 1.5 v -4.5 h -11.25 v 13.575 c 0.002,2.443 1.982,4.423 4.425,4.425 h 0.15 c 2.443,-0.002 4.423,-1.982 4.425,-4.425 0,-0.414 0.336,-0.75 0.75,-0.75 0.414,0 0.75,0.336 0.75,0.75 -0.004,3.271 -2.654,5.921 -5.925,5.925 h -0.15 C 38.288,58.112 35.638,55.462 35.634,52.191 V 38.616 h -11.25 v 4.5 h 1.5 c 0.414,0 0.75,0.336 0.75,0.75 0,0.414 -0.336,0.75 -0.75,0.75 h -4.5 c -0.414,0 -0.75,-0.336 -0.75,-0.75 0,-0.414 0.336,-0.75 0.75,-0.75 h 1.5 v -4.5 h -11.25 c -0.414,0 -0.75,-0.336 -0.75,-0.75 0,-0.414 0.336,-0.75 0.75,-0.75 h 3.769 c 0.35,-7.665 5.936,-14.077 13.481,-15.473 v -8.527 h 15 v 8.527 c 7.545,1.396 13.131,7.808 13.481,15.473 h 3.769 c 0.414,0 0.75,0.336 0.75,0.75 0,0.414 -0.336,0.75 -0.75,0.75 z m -18.75,-24 h -12 v 6.821 c 0.494,-0.045 0.994,-0.071 1.5,-0.071 h 9 c 0.506,0 1.006,0.026 1.5,0.071 z m -1.5,8.25 h -9 c -7.989,0.009 -14.573,6.271 -14.981,14.25 H 55.865 C 55.457,29.137 48.873,22.875 40.884,22.866 Z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1131"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "g1133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1135",
    clipPath: "url(#clipPath1139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1141",
    transform: "rotate(60.673208,-27.636335,374.9545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1143",
    transform: "scale(0.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1145",
    clipPath: "url(#clipPath1149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 48.084,65 41.827,58.742 39.609,56.541 V 48.066 L 8.559,17.016 C 7.3785,15.863 7.3563,13.971 8.5093,12.791 8.5257,12.774 8.5423,12.757 8.559,12.741 l 4.275,-4.275 c 1.153,-1.1805 3.045,-1.2027 4.225,-0.0497 0.017,0.0164 0.034,0.033 0.05,0.0497 l 30.975,31.05 h 8.475 l 2.237,2.256 6.258,6.258 z m 0,-23.984 H 47.461 L 47.022,40.576 16.047,9.5257 C 15.479,8.9309 14.536,8.9094 13.941,9.4777 13.925,9.4933 13.909,9.5093 13.893,9.5257 L 9.618,13.801 c -0.5948,0.568 -0.6164,1.511 -0.0481,2.106 0.0157,0.016 0.0317,0.032 0.0481,0.048 l 31.05,31.05 0.439,0.439 v 8.475 l 0.459,0.456 14.861,-14.863 -0.493,-0.496 z m 9.647,1.812 -0.248,-0.251 -14.85,14.85 0.254,0.253 5.197,5.198 14.85,-14.85 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 39.609,41.841 c -1.243,0 -2.25,-1.007 -2.25,-2.25 0,-1.243 1.007,-2.25 2.25,-2.25 1.243,0 2.25,1.007 2.25,2.25 0,1.243 -1.007,2.25 -2.25,2.25 z m 0,-3 c -0.414,0 -0.75,0.336 -0.75,0.75 0,0.414 0.336,0.75 0.75,0.75 0.414,0 0.75,-0.336 0.75,-0.75 0,-0.414 -0.336,-0.75 -0.75,-0.75 z",
    style: {
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path1153"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.e998591986664192effde99389efd0d8.svg";
export { ForwardRef as ReactComponent };